/**
 * Pdf support Content types
 */
enum PdfContentType {
  SimpleText = 'simpleText',
  Summary = 'summary',
  Tips = 'tips',
  Grids = 'grids',
  Signatures = 'signatures',
}

export { PdfContentType };
